/**
 * Apartsales — root route.
 *
 * Wraps every page in <AppShell> EXCEPT routes that opt out — currently
 * /lock/* (Phase 0 guest journey has its own minimal chrome).
 *
 * AppShell is uniform: phone frame on desktop, native fullscreen on mobile.
 * No per-route layout variants — Apartsales is one consistent app UI.
 */

import {
  createRootRouteWithContext,
  Outlet,
  useLocation,
} from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';

import { AppShell } from '~/components/AppShell';

const SHELLLESS_PREFIXES = ['/lock'];

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootLayout,
});

function RootLayout() {
  const { pathname } = useLocation();
  const isShellless = SHELLLESS_PREFIXES.some((p) => pathname.startsWith(p));

  if (isShellless) {
    return <Outlet />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
